// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wh-100[data-v-7830de0c]{width:100%;height:100%}[data-v-7830de0c] .enterpriseBody .tabfixed.fixed{max-width:unset!important;top:0!important}", ""]);
// Exports
module.exports = exports;
